import { render, staticRenderFns } from "./GroupDetailView.vue?vue&type=template&id=a2e4521a&scoped=true&"
import script from "./GroupDetailView.vue?vue&type=script&lang=js&"
export * from "./GroupDetailView.vue?vue&type=script&lang=js&"
import style0 from "./GroupDetailView.vue?vue&type=style&index=0&id=a2e4521a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e4521a",
  null
  
)

export default component.exports